import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DatalistComponent } from './datalist/datalist.component';
import { FiledataComponent } from './filedata/filedata.component';

@NgModule({
  declarations: [
    AppComponent,
    DatalistComponent,
    FiledataComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
